import { h } from "vue";

export default {
  path: "/HighlightedTopic/Narrative",
  name: "Highlighted Topic - Crash Narrative",
  type: "highlightedTopic",
  htmlContent: "HT-Narrative.html",
  keyPoints: [
    "DO NOT put Names, license plate numbers, phone numbers or other personally identifiable data in the <u>Narrative</u>. Use terms like Driver #, Vehicle #, Witness #, etc.",
    "Ensure that the <u>Narrative</u> agrees with the <u>Diagram</u>.",
  ],
  scenarios: [
    {
      name: "Detailed Diagram with Supporting Narrative",
      description: `<p><span>Example of an original narrative received and a clear version of a narrative for the same
        crash: </span><span> </span></p>
<p><strong>Original Narrative:</strong> Vehicle 1 was exiting eastbound out of the private drive of 1234 Peach Orchard
    Rd onto the 3400 block of Peach Orchard Rd US 25 (GA-121). Vehicle 2 and Witness 1 were northbound on the 3400block
    of Peach Orchard Rd, with Vehicle 2 in the left lane and Witness 1 in the middle lane. Witness 2 was standing
    outside 1234 Peach Orchard Rd, Patrick's Barber Shop. <strong><strike>Sue Smith</strike></strong> the driver of
    Vehicle 1, and both Witnesses stated that Vehicle 1 was exiting the private drive and crossed over into the left
    lane in front of Vehicle 2. The driver of Vehicle 1 said she did not see Vehicle 2 until she was entering the left
    lane. Witness 1 stated that she had been driving near Vehicle 2 since Tubman Home Rd and that in the area of the
    accident Vehicle 2 was traveling around 55 MPH.</p>
<p><strong>Clear Narrative:</strong> I arrived at the location of an <strong>angle and rollover crash</strong> at the
    <strong>Stop Sign Controlled</strong> <strong>Private Commercial Driveway intersection</strong> of 1234 Peach
    Orchard Rd onto Peach Orchard Rd US 25 (GA-121). Unit #1 was exiting the private drive to the north as Unit #2 and
    Witness #1 were northbound on Peach Orchard Rd.
</p>
<p><strong>Driver #1</strong><strong> </strong>stated that she did not see Unit 2 until she was entering the left lane.
</p>
<p><strong>Driver #2 </strong>was not able to make a statement.</p>
<p><strong>Witness #1</strong> Stated that she observed Unit #1 exiting the private drive <strong>without stopping at
        the stop sign</strong> and crossed over into the far-left lane in front of Unit 2. Witness #1 steered to the
    right to avoid Unit #1. Witness #1 stated that she had been driving near Unit 2 since Tubman Home Rd and that in the
    area of the accident Unit #2 was traveling around 55 MPH, Peach Orchard Rd is signed at 45 mph.<strong> Witness #2
    </strong>Stated that Unit #1 crossed over into the far-left lane in front of Unit #2</p>
<p><strong>Injuries: </strong>EMS arrived on scene at [TIME] to evaluate and treat injuries sustained in the crash. I
    was informed of the following: Driver #2 had a <strong>Fatal </strong>injury and was <strong>transported by EMS to
        the morgue.</strong></p>
<p><strong>Officer Investigation: </strong>The front right of Unit #2 struck the left rear of Unit #1. The impact caused
    Unit #1 to rotate counterclockwise while crossing the median and coming to an uncontrolled rest in the right lane
    facing north. The impact caused Unit #2 to swerve to the left striking the median and overturning four (4) times.
    During the overturning, Driver #2 was ejected through the windshield. Unit #2 came to an uncontrolled rest in the
    median facing east with the driver on the ground to the south of Unit #2. Driver #1 <strong>failed to yield</strong>
    while entering the roadway and made an <strong>improper right turn</strong> into the left lane. Upon inspection of
    Unit #2, the driver’s side seatbelt was retracted in the locked position indicating that Driver #2 <strong>was not
        restrained</strong> at the time of the crash.</p>
<p><strong>Vehicle Conditions: </strong>Unit #1 following a brief inspection, appeared to be good working conditions
    with adequate tire tread. and Unit #2 following a brief inspection, appeared to be in good working conditions with
    adequate tire tread. Based on the inspection there are <strong>no vehicle contributing factors</strong>.</p>
<p><strong>Roadway Conditions:</strong> Peach Orchard Rd. is a four-lane divided roadway as shown in the diagram with
    <strong>clearly visible pavement markings</strong> with a <strong>posted speed limit of 45 mph</strong>. and a right
    turn lane for the commercial driveway at 1234 Peach Orchard Rd. The road was <strong>dry and in good
        condition</strong> at the time of the crash. The private driveway onto Peach Orchard Rd. has a raised concrete
    splitter island defining the right in right out access. There is a clearly visible <strong>stop sign</strong> in
    good repair on the right shoulder of the exit lane. The driveway does not have a <strong>stop bar</strong>. There
    are <strong>no obstructions blocking visibility</strong> for vehicles exiting from the private driveway onto Peach
    Orchard Rd. Based on these conditions, there are <strong>no roadway contributing factors</strong>
</p>

<p><i>Note: The general information is the same in both, but the <strong>bolded</strong> information better identifies
        the contributing
        factors, the injury severity and specifically what the witness observed. The clear narrative also helps to
        support the
        suspected at fault party.</i></p>`,
      image: "https://crashmanual.s3.us-east-2.amazonaws.com/Scenarios/Narrative/1.png",
    },
  ],
  keywords: ["narrative", "description", "factors", "fault"],
};
